export const css = {
	root: '_2mazdeRn',
	input: '_1R4a3Fsi',
	inputWrapper: '_2n2Je0PQ Qkzz_co0 _29RvxPMs',
	checked: '_36C34EC7',
	focused: '_1XkzLfUE',
	onLabel: '_3XdpRztX',
	offLabel: '_2G79dQnp',
	disabled: '_3De6r_3_',
	readonly: '_1bP6Uffc',
	invalid: '_3CVcpEXE',
	valid: '_1Sz1dqus',
	' _key': 'certwise-theme/dojo/checkbox'
};

export default css;
